import { _ as _isNativeReflectConstruct, a as _setPrototypeOf, b as _getPrototypeOf, c as _inherits, d as _createSuper, e as _classCallCheck, f as _defineProperty, g as _assertThisInitialized } from './defineProperty-990a7015.esm.js';
import { left } from 'fp-ts/lib/Either';
import * as D from 'io-ts/lib/Decoder';
import reporter from 'io-ts-reporters';
import { i as isTagged } from './isTagged-19de68b6.esm.js';

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var CodecError = /*#__PURE__*/function (_Error) {
  _inherits(CodecError, _Error);

  var _super = _createSuper(CodecError);

  function CodecError(errors, data) {
    var _this;

    _classCallCheck(this, CodecError);

    _this = _super.call(this, "CodecError:\n".concat(Array.isArray(errors) ? reporter.report(left(errors)).join('\n') : D.draw(errors)));

    _defineProperty(_assertThisInitialized(_this), "_tag", 'CodecError');

    Object.setPrototypeOf(_assertThisInitialized(_this), CodecError.prototype);
    _this.errors = errors;
    _this.data = data;
    return _this;
  }

  return CodecError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var isCodecError = isTagged('CodecError');

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var isAxiosError = function isAxiosError(error) {
  return !!(_typeof(error) === 'object' && error && error.hasOwnProperty('isAxiosError'));
};
var is404Error = function is404Error(error) {
  return isNetworkError(error, 404);
};
var isLockError = function isLockError(error) {
  return isNetworkError(error, 423);
};
var isConflictError = function isConflictError(error) {
  return isNetworkError(error, 409);
};
var isErrorWithData = function isErrorWithData(error) {
  var _error$response;

  return isAxiosError(error) && _typeof((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) === 'object';
};
var isUnauthenticatedError = function isUnauthenticatedError(error) {
  return isNetworkError(error, '(401|403)');
};
var isCORSError = function isCORSError(error) {
  return isAxiosError(error) && error.toJSON().code === undefined;
};
var isServerError = function isServerError(error) {
  return isNetworkError(error, "5\\d\\d");
};
var isCustomErrorCode = function isCustomErrorCode(error, code) {
  var _error$response2, _error$response2$data, _error$response2$data2;

  return isAxiosError(error) && (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : (_error$response2$data2 = _error$response2$data.errors) === null || _error$response2$data2 === void 0 ? void 0 : _error$response2$data2.__code) === code;
};
var isNestCustomErrorCode = function isNestCustomErrorCode(error, code) {
  var _error$response3, _error$response3$data;

  return isAxiosError(error) && typeof ((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.statusCode) === 'number' && error.response.data.code === code;
};
var isNetworkError = function isNetworkError(error) {
  var statusCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var regex = new RegExp("^Request failed with status code ".concat(statusCode));
  return isAxiosError(error) && regex.test(error.message);
};
var MockAxiosError = /*#__PURE__*/function (_Error) {
  _inherits(MockAxiosError, _Error);

  var _super = _createSuper(MockAxiosError);

  function MockAxiosError(message) {
    var _this;

    _classCallCheck(this, MockAxiosError);

    _this = _super.call(this, typeof message === 'string' ? message : "Request failed with status code ".concat(message));

    _defineProperty(_assertThisInitialized(_this), "isAxiosError", true);

    Object.setPrototypeOf(_assertThisInitialized(_this), MockAxiosError.prototype);
    return _this;
  }

  return MockAxiosError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { CodecError as C, MockAxiosError as M, isCodecError as a, is404Error as b, isLockError as c, isConflictError as d, isErrorWithData as e, isUnauthenticatedError as f, isCORSError as g, isServerError as h, isAxiosError as i, isCustomErrorCode as j, isNestCustomErrorCode as k, isNetworkError as l };
